var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.vComponentName,{tag:"component",staticClass:"app-nav-item",attrs:{"to":_vm.vTo,"href":_vm.vHref}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }